var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 3.2666C0.828125 1.60975 2.17127 0.266602 3.82812 0.266602H29.8281C31.485 0.266602 32.8281 1.60975 32.8281 3.2666V29.2666C32.8281 30.9235 31.485 32.2666 29.8281 32.2666H3.82812C2.17127 32.2666 0.828125 30.9235 0.828125 29.2666V3.2666Z",
    fill: "#91EBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 7.74316H16.8281",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 16.2666H16.8281",
    stroke: "white",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 24.79H16.8281",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedureIcon);
export default __webpack_public_path__ + "static/media/procedureIcon.d4ff54d4e4369572214d1f5bda210575.svg";
export { ForwardRef as ReactComponent };